import type { ReactNode } from 'react';

import { Card, CardContent } from '@/components/ui/card';

export interface PageShellProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const PageShell = ({ title, description, actions, children }: PageShellProps) => (
  <div className="flex flex-col gap-4">
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
    <Card>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  </div>
);
